function updateCountdown() {
  const messageEl = document.getElementById("countdown-message");
  const now = new Date();
  // Convert to Danish time (Europe/Copenhagen handles daylight saving too)
  const danishNow = new Date(now.toLocaleString("en-US", { timeZone: "Europe/Copenhagen" }));
  // Set target today at 15:00 Danish time
  const cutoff = new Date(danishNow);
  cutoff.setHours(10, 0, 0, 0); // 15:00:00
  // Compare current Danish time with 15:00
  if(messageEl){
  if (danishNow < cutoff) {
    const diff = cutoff - danishNow;
    const hours = Math.floor(diff / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);
    messageEl.innerHTML = `Bestil inden <strong>${hours} timer ${minutes} min ${seconds} sek</strong> og vi afsender din pakke <strong>i dag</strong>.`;
  } else {
    messageEl.innerHTML = `Bestil nu og vi afsender din pakke <strong>i morgen</strong>.`;
  }
  }
}
// Update every second
setInterval(updateCountdown, 1000);
updateCountdown(); // Initial call


$(document).on('click', 'input[type="radio"]', function () {
    let inputOpation = $(this).data('opation');
    let inputLabel = $(this).data('label');
    let inventory = parseInt($(this).data('inventory'), 10);

    

    // Remove previous orange classes
    $('.inventory-icon').removeClass('orange');
    $('#stock-status').removeClass('orange');
    $('.in-stock-out').removeClass('orange');

    // Update selected value
    $('span.pro_selected_value').each(function () {
        if ($(this).data('opation') === inputOpation) {
            $(this).text(inputLabel); 
        }
    });

    // Apply 'orange' only if inventory is > 0 and < 5
    if (inventory > 0 && inventory < 5) {
        $('.inventory-icon').addClass('orange');
        $('#stock-status').addClass('orange');
        $('.in-stock-out').addClass('orange');
    }
});





$('.header__wrapper .header__main-nav .header__icon-list button').on('click',function(){
    $('html').addClass('menu_open');
})

$('.menu-drawer_overlay, .header_drawer_close').click(function(){
    $('html').removeClass('menu_open');
})
$('.menu_sub_opens > summary').on('click', function (e) {
  e.preventDefault(); // Prevent default toggle behavior
  const $parent = $(this).parent(); // This is your <details> element

  // Close all other opened menus
  $('.menu_sub_opens').not($parent).removeClass('menu-opening').removeAttr('open');

  // Toggle current menu-opening and open attribute
  if ($parent.hasClass('menu-opening')) {
    $parent.removeClass('menu-opening').removeAttr('open');
  } else {
    $parent.addClass('menu-opening').attr('open', true);
  }
});


$('.mobilesub_item_menus > .menu-drawer__inner-submenu > button').on('click', function(){
    $(this).parents().removeClass('menu-opening')
})

$('.menu_sub_inner_opens summary').on('click', function () {
    $(this).parent().siblings().removeClass('menu_openings'); // Removed the dot here
    $(this).parent().siblings().find('.menu-drawer__submenu').slideUp();
    $(this).parent().toggleClass('menu_openings');
    $(this).next().slideToggle();
});
















